import * as React from 'react';
import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { appInstance, appInfo, department } from 'src/api';
import message from 'antd/lib/message';
import { history } from 'kts-platform-frame/routes';
import { MyStore } from 'kts-platform-frame/redux';
import { Modal } from 'antd';
import AppSdk from 'kts-platform-frame/appSdk';
class ModulesAction extends ActionBasic<ModulesState> {
    /** 
     * 获取app列表(判断类型 请求不同接口)
     */
    public getAppList = async () => {
        const type = this.modulesState.searchInfo.isOpen;
        //设置列表容器的滚动条回到顶部
        this.modulesState.carouselboxContent ? this.modulesState.carouselboxContent.scrollTop = 0 : null;
        if (type === 'myApp') {
            this.getCompanyQuery();
        } else {
            this.getAppListData();
        }
    }


    /** 
     * 获取app列表
     */
    public getAppListData = async () => {
        // const isOpen = this.modulesState.isOpen;
        debugger;
        const { appCategoryId, appName, isOpen, isActivated, appClassification } = this.modulesState.searchInfo;
        const param = {
            pageNum: this.modulesState.pageNum,
            pageSize: this.modulesState.pageSize,
            appClassification: appClassification,
            appName,
            isOpen: isOpen === '0' || isOpen === '1' ? isOpen : undefined,
            appCategoryId: appCategoryId !== 0 ? appCategoryId : undefined,
            isActivated: isActivated ? isActivated : undefined
        };
        const appData = await appInfo.appInfoQuery(this, param);

        if (!appData.er) {
            this.modulesState.appList = appData.res.items;
            this.modulesState.pageNum = appData.res.pageMeta.pageNum;
            this.modulesState.total = appData.res.pageMeta.total;
            this.setModulesState(this.modulesState);
        }
    }
    /**
     * 获取app列表 我的应用
     */
    public getCompanyQuery = async () => {
        // const isOpen = this.modulesState.isOpen;
        const param = {
            pageNum: this.modulesState.pageNum,
            pageSize: this.modulesState.pageSize,
            appName: this.modulesState.searchInfo.appName,
            appCategoryId: this.modulesState.searchInfo.appCategoryId === 0 ? undefined : this.modulesState.searchInfo.appCategoryId,
        };
        const appData = await appInstance.companyQuery(this, param);

        if (!appData.er) {
            this.modulesState.appList = appData.res.items;
            this.modulesState.pageNum = appData.res.pageMeta.pageNum;
            this.modulesState.total = appData.res.pageMeta.total;
            this.setModulesState(this.modulesState);
        }
    }


    /** 获取app类型列表 */
    public getAppCategory = async () => {
        const appData = await appInstance.appCategory(this, {});
        if (!appData.er) {
            this.modulesState.appCategoryList = appData.res.list;
            this.setModulesState(this.modulesState);
        }
    }

    public openApp = (appData: any) => {
        AppSdk.instance.openApp(this, {
            appKey: appData.appKey,
            openType: 1,
            routing: ''
        });
    }

    public onSearch = () => {
        this.modulesState.pageNum = 1;
        this.setModulesState(this.modulesState);
        this.getAppList();
    }
    /** 打开弹框 */
    public openDrawerDetail = (record?: any) => {
        const { user } = MyStore.instance.getState();
        this.updata(record.appKey);
        this.modulesState.userInfo = user.userInfo;
        // this.modulesState.detailsData = record;
        this.modulesState.drawerDetailsVisible = true;
        this.setModulesState();
    }
    /**
     * 打开设置权限
     * @param record appInfo
     */
    public openDrawerSetPower = (record?: any) => {
        this.modulesState.appInfo = record ? record :
            {
                appCompany: '',
                appDescription: '',
                appIcon: '',
                appId: 0,
                appIndexUri: '',
                appIntroduction: '',
                appKey: '',
                appName: '',
                categoryName: '',
                isActivated: 0,
                appInstanceAK: '',
                appInstanceSK: '',
                appType: undefined,
                appSecret: undefined,
            };
        this.modulesState.drawerSetPowerVisible = !this.modulesState.drawerSetPowerVisible;
        this.modulesState.drawerDetailsVisible = false;
        this.setModulesState();
        this.getPermissionData();
    }

    /**
     * 分页设置
     */
    public pageSet = (page: number, pageSize: number) => {
        let pageNum: number = 0;
        if (pageSize !== this.modulesState.pageSize || page === 0) {
            pageNum = 1;
        } else {
            pageNum = page;
        }
        this.modulesState.pageNum = pageNum;
        this.modulesState.pageSize = pageSize;
        this.setModulesState();
        this.getAppList();
    }
    /**
     * 详情抽屉的打开和关闭
     * @param status 
     */
    public drawerDetailsVisibleChange = (status: boolean) => {
        this.modulesState.drawerDetailsVisible = status;
        this.setModulesState();
    }
    /**
     * 初始化当前选择的appInfo
     *
     * @param {string} appKey
     * @memberof ModulesAction
     */
    public initData = (appKey: string) => {
        this.modulesState.appKey = appKey;
        this.setModulesState(this.modulesState);
        this.getAppListData();
    }
    /** 获取数据 根据appKey获取相应应用信息 */
    public updata = async (appKey) => {
        const appData = await appInfo.appInfoGet(this, { appKey });
        if (!appData.er) {
            this.modulesState.detailsData = appData.res;
            this.setModulesState(this.modulesState);
        } else {
            history.push(`/workbench/platform/appStore/appManage`);
        }
    }
    /** 刷新秘钥 */
    public reFresh = async () => {
        const res = await appInfo.autoRefresh(this, { appKey: this.modulesState.appKey });
        if (!res.er) {
            this.initData(this.modulesState.appKey);
        }
    }
    /** 复制 */
    public copy = (name: any) => {
        const input = document.createElement('input');
        document.body.appendChild(input);
        input.setAttribute('value', this.modulesState.detailsData[name]);
        input.select();
        if (document.execCommand('copy')) {
            document.execCommand('copy');
            message.success('复制成功！');
        }
        document.body.removeChild(input);
    }

    /**
     * 是否激活app
     * @param appId 
     */
    public isActivate = async (appData: any) => {
        const param = {
            appId: appData.appId
        };
        const data = await appInfo.getPermissions(this, param);
        if (data.er) {
            return;
        }
        // 判断是否有 协议
        if (!data.res.appAgreementContent) {
            Modal.confirm({
                title: '激活提示',
                content: (
                    <p>接受许可以激活!<br />
                        {
                            data.res.appCategories.map(item => {
                                return (<div key={item.apiCategoryId}>-该应用会访问{item.apiCategoryName}</div>);
                            })
                        }
                    </p>
                ),
                onOk: () => {
                    this.appInstanceActivate(appData.appId);
                },
            });
        } else {
            this.activeTipsM(true);
            this.modulesState.appCategories = data.res.appCategories;
            this.modulesState.appAgreementContent = data.res.appAgreementContent;
            this.modulesState.appInfo = appData;
            this.setModulesState();
        }

    }
    /**
     * 禁用app
     * @param appId 
     */
    public prohibit = async ({ appId }) => {
        const appData = await appInstance.appInstanceDisable(this, { appId });
        if (!appData.er) {
            this.modulesState.drawerDetailsVisible = false;
            message.success('禁用成功!');
            this.getAppListData();
        }
    }
    /**
     * 激活应用
     */
    public appInstanceActivate = async (appId: number) => {
        const appData = await appInstance.appInstanceActivate(this, { appId });
        if (!appData.er) {
            message.success('激活成功!');
            this.modulesState.drawerDetailsVisible = false;
            // this.modulesState.appCategories = appData.res['appCategories'];
            // this.modulesState.appAgreementContent = appData.res['appAgreementContent'];
            this.activeTipsM(false);
            this.getAppListData();
        }
    }
    /** 激活弹框提示 */
    public activeTipsM = (isOpen: boolean) => {
        this.modulesState.activTipsM = isOpen;
        this.modulesState.isReadCheckd = false;
        this.setModulesState();
    }
    /** 监听 激活提示框 check按钮 */
    public onChangeCheck = (e) => {
        this.modulesState.isReadCheckd = e.target.checked;
        this.setModulesState();
    }

    //  权限方法---------------------
    /** 查询公司 人员列表 无分页 */
    public companyUserQuery = async () => {
        const companyUserQuery = await appInstance.companyUserQueryNoPage(this);
        if (!companyUserQuery.er) {
            this.modulesState.companyUserList = companyUserQuery.res as any;
            this.modulesState.companyUserFilterList = companyUserQuery.res as any;
            this.setModulesState(this.modulesState);
        }
    }
    /** 获取应用权限: 部门 或 人员 */
    public permissionQuery = async (permissionType) => {
        const param = {
            appIdList: [this.modulesState.appInfo.appId],
            permissionType,
        };
        /** 权限类型 permissionType 0-表示用户，1-表示部门 */
        const appData = await appInstance.batchPermissionQuery(null, param);
        if (!appData.er) {
            if (permissionType === 1) {
                this.modulesState.permissionDepObjects = appData.res.permissionDepObjects || {};
                this.modulesState.activeDepObjects = appData.res.activeObjects;

            } else {
                this.modulesState.permissionUserObjects = appData.res.permissionUserObjects || {};
                this.modulesState.companyUserList = [];
                this.modulesState.activeUserObjects = appData.res.activeObjects;
                this.companyUserQuery();
            }
        }
        this.setModulesState(this.modulesState);
    }

    private buildTree = (data) => {
        let dataChildList = data.filter((item) => item.parentDepartmentId);
        let dataRootList = [];
        for (let i = 0; i < data.length; i++) {
            data[i].children = [];
            if (!data[i].parentDepartmentId) {
                dataRootList.push(data[i]);
            }
        }
        let tree = this.loopChildData(dataRootList, dataChildList);
        return tree;
    }
    private loopChildData = (parent, children, insert = false) => {
        for (let i = 0; i < parent.length; i++) {
            for (let x = 0; x < children.length; x++) {
                if (parent[i].departmentId === children[x].parentDepartmentId) {
                    parent[i].children.push(children[x]);
                }
            }
            if (parent[i].children.length > 0) {
                this.loopChildData(parent[i].children, children, true);
            }
        }
        if (insert) {
            return;
        } else {
            return parent;
        }
    }

    /**
     *  查询部门信息
     */
    public departmentQuery = async () => {
        const res = await department.depList(this);
        if (!res.er) {
            this.modulesState.departmentQuery = res.res.map((item, index) => {
                return {
                    ...item,
                    value: item.departmentId,
                    key: index,
                    label: item.name,
                };
            });
            this.modulesState.departtreeDate = this.buildTree(this.modulesState.departmentQuery);
            this.modulesState.departmentFilterList = this.buildTree(this.modulesState.departmentQuery);
            this.modulesState.openTabVisible = 'companyUser';
            this.setModulesState();
        }
    }
    /**
     * 根据相应的选择人员列表展示的tab页查询当前tab页的权限信息
     *
     * @memberof ModulesAction
     */
    public getPermissionData = () => {
        const type = this.modulesState.openTabVisible;
        const appId = this.modulesState.appInfo.appId;
        if (appId === 0) {
            return;
        }
        if (type === 'department') { //部门
            this.permissionQuery(1);
        } else {
            this.permissionQuery(0);
        }
    }


    /**
     *  批量添加权限
     *
     * @param {*} item 当前选择节点信息
     * @param {boolean} flag 添加权限 | 移除权限 true | false
     * @param {number} [isDep=0] 是否是部门 1 是部门 0 是人员
     * @memberof ModulesAction
     */
    public setPowerHandle = (item: any, flag: boolean, isDep: number = 0) => {
        !isDep ? this.batchPermissionUser(item, flag) : this.batchPermissionDep(item, flag);
    }
    batchPermissionDep = (objInfo: any, flag: boolean) => {
        const objectType = 1;
        const powerData = { objectId: objInfo.departmentId, objectType };
        const permissionData = this.modulesState.permissionDepObjects;
        if (JSON.stringify(permissionData) === '{}') {
            const data = this.modulesState.appInfo;
            let appPower = permissionData[data.appId];
            if (appPower) {
                appPower.push(powerData);
            } else {
                permissionData[data.appId] = [powerData];
            }
        } else {
            const data = this.modulesState.appInfo;
            let appPower = permissionData[data.appId];
            if (appPower) {
                if (flag) { // 当前操作为添加权限
                    appPower.push(powerData);
                } else {
                    permissionData[data.appId] = appPower.filter(i => !(objInfo.departmentId === i.objectId));
                }
            } else {
                permissionData[data.appId] = [];
                permissionData[data.appId].push(powerData);
            }
        }
        this.setModulesState(this.modulesState, () => {
            this.batchPermissionOverride({
                permissionBizObjects: this.modulesState.permissionDepObjects,
                permissionType: objectType
            });
        });
    }
    /**
     * 
     *
     * @param {*} item 当前选择的人员信息
     * @param {boolean} flag flag 添加权限 | 移除权限 true | false
     * @memberof ModulesAction
     */
    batchPermissionUser = (objInfo: any, flag: boolean) => {
        const objectType = 0;
        const powerData = { objectId: objInfo.userId, objectType };
        const permissionData = this.modulesState.permissionUserObjects;
        if (JSON.stringify(permissionData) === '{}') {
            const data = this.modulesState.appInfo;
            let appPower = permissionData[data.appId];
            if (appPower) {
                appPower.push(powerData);
            } else {
                permissionData[data.appId] = [powerData];
            }
        } else {
            const data = this.modulesState.appInfo;
            let appPower = permissionData[data.appId];
            if (appPower) {
                if (flag) { // 当前操作为添加权限
                    appPower.push(powerData);
                } else {
                    permissionData[data.appId] = appPower.filter(i => !(objInfo.userId === i.objectId));
                }
            } else {
                permissionData[data.appId] = [];
                permissionData[data.appId].push(powerData);
            }

        }
        this.setModulesState(this.modulesState, () => {
            this.batchPermissionOverride({
                permissionBizObjects: this.modulesState.permissionUserObjects,
                permissionType: objectType
            });
        });

    }
    /**
     *  批量提交权限
     *
     * @param {*} params
     * @memberof ModulesAction
     */
    batchPermissionOverride = async (params: any) => {
        const appData = await appInstance.batchPermissionOverride(null, params);
        if (appData.res) {
            message.success('授权成功');
        }
        this.getPermissionData();
        this.setModulesState();
    }

    /**
     * 过滤当前有协作人员得部门
     * @param depHas 
     * @param data 
     * @returns 
     */
    public getDepartmentFilterListByTeamwork = () => {
        // 获取当前拥有协作人员得部门Array
        const activeUserList = this.modulesState.companyUserFilterList.filter(item => this.modulesState.activeUserObjects.indexOf(item.userId) !== -1).map(item => item.departmentId);
        // 在整体得部门树中过滤出拥有协作人员得部门树
        this.modulesState.departmentFilterListByTeamwork = this.filterList(activeUserList, JSON.parse(JSON.stringify(this.modulesState.departtreeDate)));
        this.setModulesState();
    }
    /**
     * 过滤当前有公司人员得部门  暂未使用
     * @param depHas 
     * @param data 
     * @returns 
     */
    public getDepartmentFilterListByCompanyUser = () => {
        // 获取当前拥有协作人员得部门Array
        const activeUserList = this.modulesState.companyUserFilterList.map(item => item.departmentId);
        if (activeUserList.length > 0) {
            // 在整体得部门树中过滤出拥有人员得部门树
            this.modulesState.departmentFilterListByCommanyUser = this.filterList(activeUserList, JSON.parse(JSON.stringify(this.modulesState.departtreeDate)));
        } else {
            this.modulesState.departmentFilterListByCommanyUser = [];
        }

        this.setModulesState();
    }
    /**
     *  判断当前部门及子部门下是否有相应的人员
     * @param ur 
     * @param dep 
     * @returns 
     */
    hasUser(ur: string[], dep: any) {
        let flag = false;
        if (ur.indexOf(dep.departmentId) > -1) {
            flag = true;
        } else {
            if (dep.children && dep.children.length > 0) {
                flag = dep.children.some(item => {
                    return this.hasUser(ur, item);
                });
            } else {
                flag = false;
            }
        }
        return flag;
    }
    /**
     * 过滤当前有协作人员得部门
     * @param depHas 
     * @param data 
     * @returns 
     */
    public filterList = (depHas: string[], data: any) => {
        const newData = data.filter(element => this.hasUser(depHas, element));
        newData.forEach(x => {
            if (x.children && x.children.length > 0) {
                x.children = this.filterList(depHas, x.children);
            }
        });
        return newData;
    }

    /**
     * 列表页，详情抽屉中了解更多功能
     * @param appDocUrl 
     */
    understandMore = (appDocUrl: any) => {
        window.open(appDocUrl);
    }

}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManage/Modules.Action.tsx